
import { useSelector  } from 'react-redux';

import { getSearchProjectId } from '../reducers/project';

export default function useSearchProjectId() {
    const projectId = useSelector(state => getSearchProjectId(state.project));
    return projectId;
}
